import stepLayout from './index.vue';

stepLayout.install = (Vue) => {
  Vue.component(stepLayout.name, stepLayout);
};

export default stepLayout;
